// extracted by mini-css-extract-plugin
export var buttonContent = "_3g-0";
export var centered = "_3g-1";
export var centeredFlex = "_3g-2";
export var errorText = "_3g-3";
export var icon = "_3g-4";
export var iconButtonContent = "_3g-5";
export var monospace = "_3g-6";
export var padded = "_3g-7";